import {apiName} from '../amplify';
import {SessionAwareClient} from './SessionAwareClient';
// Renouvelle la session et rejoue la requête sur un 403 de la passerelle (cf. `SessionAwareClient`).
export const perfectPostServiceClient = new SessionAwareClient(apiName);
export {CrispClient} from './Crisp';
